﻿import React from "react";
import { IGroup } from "@fluentui/react/lib/DetailsList";
import { InteractionFeedbackItem } from "../../interfaces";
import { assistantCodes } from "../../lsts";
import styles from "../AnalyticsConvoList/AnalyticsConvoList.module.css";

interface CollectedDataTableProps {
    group: IGroup;
    assistantType: string;
}

const formatKey = (key: string) =>
    key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

const CollectedDataTable: React.FC<CollectedDataTableProps> = ({ group, assistantType }) => {
    if (!group?.data?.collecteddata || typeof group.data.collecteddata !== "object" || Array.isArray(group.data.collecteddata)) {
        return <div className={styles.noDataText}>No Collected Data</div>;
    }

    return (
        <div className={styles.cardDataGrid}>
            {assistantType === assistantCodes.cca ? (
                Object.entries(group.data.collecteddata).map(([k, v]) => (
                    <div key={k} className={styles.cardDataRow}>
                        <span className={styles.cardDataLabel}>{formatKey(k)}</span>
                        <span className={styles.cardDataValue}>{typeof v === "object" ? JSON.stringify(v) : String(v)}</span>
                    </div>
                ))
            ) : group?.data?.feedback && group?.data?.feedback.length > 0 ? (
                <>
                    <div className={styles.cardDataRow}>
                        <span className={styles.cardDataLabel}>User</span>
                        <span className={styles.cardDataValue}>{group?.data.email || "—"}</span>
                    </div>
                    <div className={styles.cardDataRow}>
                        <span className={styles.cardDataLabel}>Responses</span>
                        <span className={styles.cardDataValue}>{group.count || 0}</span>
                    </div>
                    {group.data.duration && group.data.duration != 0 && (
                        <div className={styles.cardDataRow}>
                            <span className={styles.cardDataLabel}>Active</span>
                            <span className={styles.cardDataValue}>{group.data.duration}</span>
                        </div>
                    )}
                    <div className={styles.cardDivider} />
                    <span className={styles.cardSectionTitle}>Feedback</span>
                    {group.data.feedback.map((item: InteractionFeedbackItem, idx: number) => (
                        <div key={idx} className={styles.cardDataRow}>
                            <span className={styles.cardDataLabel}>{item.positive}</span>
                            <span className={styles.cardDataValue}>{item.feedback}</span>
                        </div>
                    ))}
                </>
            ) : (
                <>
                    <div className={styles.cardDataRow}>
                        <span className={styles.cardDataLabel}>User</span>
                        <span className={styles.cardDataValue}>{group?.data.email || "—"}</span>
                    </div>
                    <div className={styles.cardDataRow}>
                        <span className={styles.cardDataLabel}>Responses</span>
                        <span className={styles.cardDataValue}>{group.count || 0}</span>
                    </div>
                    {group.data.duration && group.data.duration != 0 ? (
                        <div className={styles.cardDataRow}>
                            <span className={styles.cardDataLabel}>Active</span>
                            <span className={styles.cardDataValue}>{group.data.duration}</span>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
};

export default CollectedDataTable;
